import * as Types from '../../tenants/kwg/generated';

import { RoleAssignmentFragmentDoc } from './roleAssignments.fragment.g';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';


export const CreateRoleAssignmentDocument = `
    mutation CreateRoleAssignment($input: CreateRoleAssignmentCommandInput!) {
  createRoleAssignment(input: $input) {
    ...RoleAssignment
  }
}
    ${RoleAssignmentFragmentDoc}`;

export const useCreateRoleAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<Types.CreateRoleAssignmentMutation, TError, Types.CreateRoleAssignmentMutationVariables, TContext>) => {
    
    return useMutation<Types.CreateRoleAssignmentMutation, TError, Types.CreateRoleAssignmentMutationVariables, TContext>(
      {
    mutationKey: ['CreateRoleAssignment'],
    mutationFn: (variables?: Types.CreateRoleAssignmentMutationVariables) => fetcher<Types.CreateRoleAssignmentMutation, Types.CreateRoleAssignmentMutationVariables>(CreateRoleAssignmentDocument, variables)(),
    ...options
  }
    )};

export const UpdateRoleAssignmentDocument = `
    mutation UpdateRoleAssignment($input: UpdateRoleAssignmentCommandInput!) {
  updateRoleAssignment(input: $input) {
    ...RoleAssignment
  }
}
    ${RoleAssignmentFragmentDoc}`;

export const useUpdateRoleAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpdateRoleAssignmentMutation, TError, Types.UpdateRoleAssignmentMutationVariables, TContext>) => {
    
    return useMutation<Types.UpdateRoleAssignmentMutation, TError, Types.UpdateRoleAssignmentMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRoleAssignment'],
    mutationFn: (variables?: Types.UpdateRoleAssignmentMutationVariables) => fetcher<Types.UpdateRoleAssignmentMutation, Types.UpdateRoleAssignmentMutationVariables>(UpdateRoleAssignmentDocument, variables)(),
    ...options
  }
    )};

export const DeleteRoleAssignmentDocument = `
    mutation DeleteRoleAssignment($input: DeleteRoleAssignmentCommandInput!) {
  deleteRoleAssignment(input: $input) {
    ...RoleAssignment
  }
}
    ${RoleAssignmentFragmentDoc}`;

export const useDeleteRoleAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<Types.DeleteRoleAssignmentMutation, TError, Types.DeleteRoleAssignmentMutationVariables, TContext>) => {
    
    return useMutation<Types.DeleteRoleAssignmentMutation, TError, Types.DeleteRoleAssignmentMutationVariables, TContext>(
      {
    mutationKey: ['DeleteRoleAssignment'],
    mutationFn: (variables?: Types.DeleteRoleAssignmentMutationVariables) => fetcher<Types.DeleteRoleAssignmentMutation, Types.DeleteRoleAssignmentMutationVariables>(DeleteRoleAssignmentDocument, variables)(),
    ...options
  }
    )};
